import { X } from 'react-feather';
import type { ToastComponentProps } from './interfaces';
import styles from './style.module.css';
import * as Toast from './Toast.Base';

type Props = ToastComponentProps;

export const Error = (props: Props) => {
  return (
    <Toast.Base
      Icon={X}
      iconClassName={styles.error}
      body={props.body}
      title={props.title} />
  );
};

Error.displayName = 'Toast.Error';